import { createFileRoute } from "@tanstack/react-router"

import TabsLayout from "@/components/common/TabsLayout/TabsLayout"

const tabs = [{ id: "gl-transactions", label: "GL Transactions", path: "/app/accounting/gl-transactions" }]

export const Route = createFileRoute("/app/accounting/_layout")({
  component: AccountingLayout,
})

function AccountingLayout() {
  return <TabsLayout title='Accounting' tabs={tabs} />
}
